
import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  Input,
  Button,
  Row,
  Col,
  Link,
} from 'element-ui';
import api from '@/api/helpQues';
import { Message } from '@/plugin/message/index';
import vueClipboard from 'vue-clipboard2';

Vue.use(vueClipboard);

@Component({
  components: {
    Input,
    Button,
    Row,
    Col,
    Link,
  },
})

export default class otherQues extends Vue {
  private allQuestion: any = [];

  private show: boolean = true;

  private search: string = '';

  private otherQuestionList: any = [];

  mounted() {
    api.getMualByType().then((res: any) => {
      res.map((el:any) => {
        const user:any = {
          title: el.helpType,
          text: [],
          status: false,
        };
        el.helpManuals.map((em: any) => {
          const url = `//help.manage.coding4fun.com.cn/detail/${em.pid}
          /${em.helpTitle}/${em.helpType}/${em.helpTitle}`;
          const texts = {
            texts: em.helpTitle,
            value: `[${em.helpTitle}](${encodeURI(url)})`,
          };
          user.text.push(texts);
          return true;
        });
        this.allQuestion.push(user);
        return true;
      });
    });
  }

  statusOpen(item: any) {
    this.$set(item, 'status', !item.status);
  }

  handleSearch() {
    if (this.search) {
      this.show = false;
      api.getAllMual(this.search).then((res: any) => {
        if (res) {
          this.otherQuestionList = [];
          this.otherQuestionList = res.map((el: any) => {
            const url = `//help.manage.coding4fun.com.cn/detail/${el.pid}
            /${el.helpTitle}/${el.helpType}/${el.helpTitle}`;
            return {
              label: el.helpTitle,
              value: `[${el.helpTitle}](${encodeURI(url)})`,
            };
          });
        }
      });
    }
  }

  doCopy(value: string) {
    this.$copyText(value).then(() => {
      Message.success('复制成功');
    }, () => {
      Message.error('复制失败');
    });
  }
}
